/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import * as THREE from 'three';
import { TextureLoader } from 'three';
import { useThree, useLoader } from '@react-three/fiber';

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { controls } from '../../../../../../redux/reducers/common/eventReducer';
import { delModel, extrudeSettings, textureAnisotropy } from '../../../../../../utils/Functions';

const InsideWallModel = () => {
    const { gl } = useThree();

    const texture = const_var.metalTexture;

    const wallModel = useMemo(() => {
        let model = new THREE.Shape();

        if (params.p_r_s === 1) {
            const innerRoofWidth = params.p_w - 0.01
            const innerRoofPorchSize = params.p_r_p - 0.02
            
            model.moveTo(-innerRoofWidth / 2 + 0.0001, params.p_h);

            model.lineTo(-innerRoofWidth / 2, params.p_h + 0.3);
            model.lineTo(-innerRoofWidth / 2 + 0.02, params.p_h + 0.34);
            model.lineTo(-innerRoofWidth / 2 + 0.055, params.p_h + 0.38);
            model.lineTo(-innerRoofWidth / 2 + 0.1, params.p_h + 0.4);
    
            model.lineTo(0, params.p_h + (innerRoofPorchSize / 12) * innerRoofWidth / 2 + 0.4);
    
            model.lineTo(innerRoofWidth / 2 - 0.1, params.p_h + 0.4);
            model.lineTo(innerRoofWidth / 2 - 0.055, params.p_h + 0.38);
            model.lineTo(innerRoofWidth / 2 - 0.02, params.p_h + 0.34);
            model.lineTo(innerRoofWidth / 2, params.p_h + 0.3);
    
            model.lineTo(innerRoofWidth / 2 +0.005, params.p_h);

            model.lineTo(innerRoofWidth / 2 +0.005, 0.01);
            model.lineTo(-innerRoofWidth / 2 +0.005, 0.01);
    
            model.closePath()
    
        } else if (params.p_r_s === 2 || params.p_r_s === 3) {
            model.moveTo(-params.p_w / 2 + 0.1, params.p_h - 0.001);
            model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
            model.lineTo(params.p_w / 2 - 0.1, params.p_h - 0.001);
            model.lineTo(params.p_w / 2 - 0.1, 0.01);
            model.lineTo(-params.p_w / 2 + 0.1, 0.01);
            model.closePath()
        }

        return model;
    
    }, [params.p_w, params.p_h, params.p_r_s, params.p_r_p])

    /************** cutting hole using CSG ***************/
    const CSGWallModelGeometry = useMemo(() => {
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallModel, extrudeSettings(0.005)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backStorageFront', 'wall'), extrudeSettings(1)))

        let meshWallModel_Temp = meshWallModel.clone();
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(0, 0, -0.5);

        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        const wallModel_CSG =  meshWallModel_CSG.subtract(meshDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            wallModel_CSG,
            new THREE.Matrix4()
        )

        return CSGWallModel.geometry
    }, [wallModel, const_var.newDoorsArray])

    /****************************************** *********/

    useMemo(() => {
        textureAnisotropy(gl, texture, 1.3, 1.3, params.p_v_w ? Math.PI / 2 : 0);
    
    }, [params.p_v_w])


    return CSGWallModelGeometry && (
        <group onPointerOver={e => e.stopPropagation()} onPointerDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()} >
            <mesh name="back-storage-inside-wall" geometry={CSGWallModelGeometry} position={[0, 0, params.p_d / 2 - parseInt(params.cB_addStorage_front) + 0.01]}>
                <meshBasicMaterial onUpdate={(self) => {self.needsUpdate = true}} map={texture}  side={THREE.DoubleSide} color={"#C9C9C9"}  transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02}/>
            </mesh>
        </group>
    )
}

export default InsideWallModel